














































import { Component, Vue } from 'vue-property-decorator';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import { BButton, BIconPlus, BModal } from 'bootstrap-vue';
import DataTable from '@/components/DataTable.vue';
import UserFilter from '@/components/UserFilter.vue';
import UserFilterOptions from '@/types/UserFilterOptions';
import UserList from '@/components/UserList.vue';
import UserDetails from '@/components/UserDetails.vue';

@Component({
    components: {
        'default-layout': DefaultLayout,
        'data-table': DataTable,
        'user-filter': UserFilter,
        'user-details': UserDetails,
        'user-list': UserList,
        'b-btn': BButton,
        'b-icon-plus': BIconPlus,
        'b-modal': BModal
    }
})
export default class UsersView extends Vue {
    userId = ''
    showModal = false;
    refreshList = false;
    modalTitle = '';
    filter: UserFilterOptions = {
        sequenceOrName: null,
        isActive: true,
        projectId: null
    }

    onUserSelected(id: string) {
        this.userId = id;
        this.modalTitle = this.$t('modal.userDetailsTitle') as string;
        this.showModal = true;
    }

    onLoadComplete() {
        this.refreshList = false;
    }

    onUserSaved(result: boolean) {
        this.showModal = false;

        if (result) {
            this.refreshList = true;
        }
    }

    onUserDeleted() {
        this.showModal = false;
        this.refreshList = true;
    }

    addNewUser() {
        this.userId = '';
        this.modalTitle = this.$t('modal.newUserTitle') as string;
        this.showModal = true;
    }

    onFilterList(filter: UserFilterOptions) {
        this.filter = filter;
        this.refreshList = true;
    }
}
